module.exports = __webpack_public_path__ + "static/media/bountyhub-creator.835fdf6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bountyhub-creator.png
// module id = 188
// module chunks = 0